module.exports = __webpack_public_path__ + "static/img/service_h5_07_zh.4bfe3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_h5_07_zh.png
// module id = Fdg3
// module chunks = 34